// Portal controllers index — EAGER registrations only.
//
// Registers above-the-fold or ambient controllers that may be triggered
// before any lazy chunk has had a chance to load. Everything else is
// registered lazily via lazy_index.js + bootLazyControllers.
import { application } from "./application"

import AuthModalController from "./auth_modal_controller"
application.register("auth-modal", AuthModalController)

import VipModalController from "./vip_modal_controller"
application.register("vip-modal", VipModalController)

import QuizFlowModalController from "./quiz_flow_modal_controller"
application.register("quiz-flow-modal", QuizFlowModalController)

import FlashToastController from "./flash_toast_controller"
application.register("flash-toast", FlashToastController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import SearchFormController from "./search_form_controller"
application.register("search-form", SearchFormController)

import PushNotificationPromptController from "./push_notification_prompt_controller"
application.register("push-notification-prompt", PushNotificationPromptController)

import ReportModalController from "./report_modal_controller"
application.register("report-modal", ReportModalController)

import PlayerReportController from "./player_report_controller"
application.register("player-report", PlayerReportController)

import PetController from "./pet_controller"
application.register("pet", PetController)
